import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { NodeTextField } from "@/components/doc/right-sidebar/active-node-style/fields/NodeTextField";
import { Sidebar } from "@/components/sidebar";

import type { GraphNodeAttrs } from "@/components/tiptap/Graph";
import type { DocumentModel } from "@/models/DocumentModel";

type Props = {
  doc: DocumentModel;
  graphAttrs: GraphNodeAttrs;
};

export const GraphAxisLabels = observer(function GraphAxisLabels({ doc, graphAttrs }: Props) {
  const { tiptap } = doc.editor;
  const t = useTranslations("sidebar.activeNode");

  if (!tiptap) return null;

  const handleOnChange = (axis: "x" | "y") => (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;

    tiptap.commands.updateAttributes("graph", {
      [`${axis}AxisLabel`]: value,
    });
  };

  return (
    <>
      <Sidebar.SectionTitle className="text-xxxs text-gray-500">
        {t("graph.title.labels")}
      </Sidebar.SectionTitle>
      <div className="flex bg-document-bg shadow-block dark:shadow-block-inverted rounded-6">
        <NodeTextField
          id="graph-x-axis"
          value={graphAttrs.xAxisLabel || ""}
          name="x"
          className="border-r border-r-gray-200 dark:border-r-gray-700"
          onChange={handleOnChange("x")}
          labelProps={{
            label: "x",
          }}
        />
        <NodeTextField
          id="graph-y-axis"
          value={graphAttrs.yAxisLabel || ""}
          name="y"
          onChange={handleOnChange("y")}
          labelProps={{
            label: "y",
          }}
        />
      </div>
    </>
  );
});
